import * as React from 'react';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import LinkIcon from '@mui/icons-material/Link';
import DeleteIcon from '@mui/icons-material/Delete';

export default function BasicSpeedDial({
  onClickDelete,
  onClickCancel,
  onClickEdit,
  onClickWorkflow,
  pagamento,
}) {
  return (
    <Box sx={{ transform: 'translateZ(0px)', flexGrow: 1 }}>
      <SpeedDial
        ariaLabel="SpeedDial basic example"
        sx={{ position: 'absolute', bottom: -30, right: -2 }}
        icon={<SpeedDialIcon />}
        direction="left"
      >
        {pagamento && pagamento.status === 'RASCUNHO' ? (
          <SpeedDialAction
            onClick={() => onClickDelete(pagamento)}
            key={'Excluir'}
            icon={<DeleteIcon color="error" />}
            tooltipTitle={'Excluir'}
          />
        ) : null}
        {(pagamento && pagamento.status == 'RASCUNHO') ||
        pagamento.status == 'ERRO' ? (
          <SpeedDialAction
            onClick={() => onClickEdit(pagamento)}
            key={'Editar'}
            icon={<BorderColorIcon color="primary" />}
            tooltipTitle={'Editar'}
          />
        ) : null}
        {pagamento &&
        ![
          'PROCESSO FINALIZADO',
          'RASCUNHO',
          'PAGO',
          'DOCUMENTO CANCELADO',
          'CANCELADO',
          'EM CANCELAMENTO',
        ].includes(pagamento.status.toUpperCase()) ? (
          <SpeedDialAction
            onClick={() => onClickCancel(pagamento)}
            key={'Cancelar'}
            icon={<DoNotDisturbIcon color="error" />}
            tooltipTitle={'Cancelar'}
          />
        ) : null}

        {pagamento && pagamento.status != 'RASCUNHO' ? (
          <SpeedDialAction
            onClick={() => onClickWorkflow(pagamento)}
            key={'Workflow'}
            icon={<LinkIcon color="primary" />}
            tooltipTitle={'Abrir Workflow'}
          />
        ) : null}
      </SpeedDial>
    </Box>
  );
}
